// src/utils/validateCharset.ts
export function validateUtf8mb4(value: string): boolean {
    // 正则解释：\P{C} 表示非控制字符，u 标志启用 Unicode 模式
    return /^\P{C}*$/u.test(value);
  };